module.exports = __webpack_public_path__ + "img/2017nianhui.09bcd964.png";